export const getOtzyvyUrl = (isMoscow: boolean, reviewsCount?: number | null): string => {
  if (isMoscow) {
    return reviewsCount ? 'otzyvy/' : '#reviews-form';
  }

  return '#reviews';
};
